import { clientOnlyCheck } from '../utils/client-only';

/** The dashboard's own production host. */
export const PRODUCTION_HOST = 'app.sparklayer.io';

/** The production host the dashboard is served from when embedded in the Shopify admin. */
export const EMBEDDED_PRODUCTION_HOST = 'shop.ignite.sparklayer.io';

/** The shared development host — branch builds are served from sub-paths of it. */
export const DEVELOPMENT_HOST = 'app.dev.sparklayer.io';

/**
 * Whether `host` serves production merchants, embedded or not. Anything host-keyed that must match
 * a real merchant's environment (app slugs, OAuth client IDs) has to go through this, otherwise the
 * embedded host silently falls through to development credentials.
 */
export function isProductionHost(host: string): boolean {
  return host === PRODUCTION_HOST || host === EMBEDDED_PRODUCTION_HOST;
}

export const isProduction = clientOnlyCheck(() => window.location.host === PRODUCTION_HOST);

export const shopifyAppSlug = clientOnlyCheck(() => isProductionHost(window.location.host))
  ? 'sparklayer'
  : 'sparklayer-dev';
